<h3 [ngStyle]="{'color': getPrimaryColor()}">สมัครใช้บริการ</h3>
<form autocomplete="off" [formGroup]="registerForm" class="uk-margin-small-bottom uk-text-left" novalidate (ngSubmit)="onSubmit()">
    <div>
        <label for="id-card" class="uk-form-label">เลขที่บัตรประจำตัวประชาชน</label>
        <div class="uk-form-controls uk-position-relative">
            <input id="id-card" 
                class="uk-input uk-border-rounded" 
                type="text" placeholder="กรุณาระบุหมายเลขบัตรประชาชน"
                mask="0-0000-00000-00-0" 
                autocomplete="off"
                formControlName="idCard"
                maxlength="17"
                [class.uk-form-danger]="registerForm.get('idCard')?.invalid && registerForm.get('idCard')?.touched"/>
                @if (registerForm.get('idCard')?.invalid && registerForm.get('idCard')?.touched || registerForm.get('idCard')?.dirty) {
                    <small class="uk-text-danger uk-animation-fast"
                        tabindex="-1">
                        @if (registerForm.get('idCard')?.errors?.required && registerForm.get('idCard')?.touched) {
                            <span>กรุณาระบุหมายเลขบัตรประชาชน</span>
                        }
                        @if (registerForm.get('idCard')?.errors?.invalidThaiID && registerForm.get('idCard')?.touched) {
                            <span>กรุณาระบุหมายเลขบัตรประชาชนให้ถูกต้อง</span>
                        }
                    </small>
                }
        </div>
    </div>
    <div>
        <label for="mobile" class="uk-form-label">หมายเลขโทรศัพท์มือถือ</label>
        <div class="uk-form-controls uk-position-relative">
            <input 
            id="mobile" 
            class="uk-input uk-border-rounded" 
            type="text" 
            placeholder="กรุณาระบุหมายเลขโทรศัพท์มือถือ"
            autocomplete="off" 
            (keyup)="onKeyPress($event)" 
            minlength="10" 
            maxlength="10" 
            inputmode="decimal"
            mask="0000000000"
            formControlName="mobile"
            [pattern]="regTel"
            [class.uk-form-danger]="registerForm.get('mobile')?.invalid && registerForm.get('mobile')?.touched"
            />
            <small class="uk-text-danger uk-animation-fast"
                tabindex="-1">
                @if (registerForm.get('mobile')?.errors?.required && registerForm.get('mobile')?.touched) {
                    <span>กรุณาระบุหมายเลขโทรศัพท์มือถือ</span>
                }
                @if (registerForm.get('mobile')?.errors?.pattern && registerForm.get('mobile')?.touched) {
                    <span>กรุณาระบุหมายเลขโทรศัพท์มือถือให้ถูกต้อง</span>
                }
            </small>
        </div>
    </div>
    <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal">
        <button type="submit"
            class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
            [ngStyle]="{'background-color': getPrimaryColor()}"
            [disabled]="registerForm.invalid">ถัดไป
        </button>
    </div>
    @if(invalidInformation()) {
        <div class="uk-text-center">
            <p class="uk-text-center uk-text-meta uk-margin-small-bottom"><small>หากท่านต้องการแก้ไขข้อมูล กรุณาติดต่อ</small></p>
            <div><a href="tel:026336060" class="uk-h5"><img src="/assets/images/icon-tel.svg" uk-svg class="tel-icon" width="15" height="15"> 0 2633 6060</a></div>    
        </div>
    }
</form>
